import React, { createContext, useEffect, useState } from 'react'
import { useUnleashContext } from '@unleash/proxy-client-react'

import OrbitSession from '../hooks/useCookies'
import {
  Identity,
  IdentityContextInterface
} from '../types/context/IdentityContextInterface'

export const IdentityContext = createContext<
  IdentityContextInterface | undefined
>(undefined)

type IdentityProviderProps = {
  children?: React.ReactNode
}

/**
 * Sets the context with user information.
 */
const IdentityProvider: React.FC<IdentityProviderProps> = (props) => {
  const [identity, setIdentity] = useState<Identity | undefined>(() => {
    const _id = OrbitSession.get('_id')
    if (!_id) {
      return undefined
    }

    const keys: Array<keyof Identity> = [
      'email',
      'role',
      'orgId',
      '_id',
      'userName'
    ]

    const i: Partial<Identity> = {}
    keys.forEach((k) => {
      i[k] = OrbitSession.get(k) || ''
    })
    return i as Identity
  })

  const provider = OrbitSession.get('provider')
  const orgId = OrbitSession.get('orgId')

  // TODO: get the type bindings for updateContext
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let updateContext: any

  if (provider === 'UL') {
    updateContext = useUnleashContext()
  }

  useEffect(() => {
    if (provider === 'UL') {
      updateContext({ userId: orgId })
    }
  }, [])

  return (
    <IdentityContext.Provider value={{ identity, setIdentity }} {...props} />
  )
}

export default IdentityProvider
